import React from 'react';

import Link from '../../Generic/Link/Link';
import TRANSLATIONS from './translations@default.json';

const NewEnergyRatingInformation = () => {
	return (
		<div className="text-sm md:text-body-xs text-primary px-4 mt-1 md:pt-0 md:mb-4">
			<div className="bg-gray-10 p-4 rounded">
				<span className="font-bold">{TRANSLATIONS.newEnergyScale}</span>
				{TRANSLATIONS.paragraph1}
				<div className="pt-2 pb-1">{TRANSLATIONS.paragraph2}</div>

				<Link
					dataTag="energy rating message learn more"
					url={TRANSLATIONS.link}
					classes="text-link font-bold"
					text={TRANSLATIONS.learnMore}
					OpenInNewWindow
				/>
			</div>
		</div>
	);
};
export default NewEnergyRatingInformation;
